import { createSelector } from 'reselect';
const repSelector = state => state.rep;

// REPS
export const reps = createSelector(repSelector, state => state.reps);
export const repOptions = createSelector(reps, reps =>
  reps.map(rep => ({
    value: rep.id,
    text: rep.name,
    key: rep.id,
  }))
);
export const current = createSelector(repSelector, state => state.current);
export const count = createSelector(repSelector, state => state.count);
export const pages = createSelector(repSelector, state => state.pages);
export const activePage = createSelector(repSelector, state => state.activePage);
export const query = createSelector(repSelector, state => state.query);
